<template>
  <v-container class="d-flex flex-column ga-3">
    <v-row>
      <v-col>
        <UsageExample v-model="tab" :code="code1" :tabs="tabs">
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Default</v-card-title>
            <v-card-text class="d-flex ga-3 flex-wrap">
              <v-layout>
                <hx-toolbar
                  id="toolbar-id"
                  v-model:collapsed="collapseToolbar"
                  :header-title="
                    !longTitle ? 'Floating title' : 'Floating title with a very long title'
                  "
                >
                  <hx-toolbar-body-section
                    :style="!longContent ? 'height: 100px' : 'height: 250px'"
                  >
                    <div
                      class="d-flex justify-center align-center border-dashed rounded h-100 w-100"
                    >
                      insert component
                    </div>
                  </hx-toolbar-body-section>
                  <hx-toolbar-body-section>
                    <hx-toolbar-body-section-content-block>
                      <div
                        class="d-flex justify-center align-center border-dashed rounded h-100 w-100"
                      >
                        insert component
                      </div>
                    </hx-toolbar-body-section-content-block>
                    <hx-toolbar-body-section-content-block>
                      <div
                        class="d-flex justify-center align-center border-dashed rounded h-100 w-100"
                      >
                        insert component
                      </div>
                    </hx-toolbar-body-section-content-block>
                  </hx-toolbar-body-section>
                  <hx-toolbar-body-section>
                    <hx-toolbar-body-section-content-block>
                      <div
                        class="d-flex justify-center align-center border-dashed rounded h-100 w-100"
                      >
                        insert component
                      </div>
                    </hx-toolbar-body-section-content-block>
                    <hx-toolbar-body-section-content-block>
                      <div
                        class="d-flex justify-center align-center border-dashed rounded h-100 w-100"
                      >
                        insert component
                      </div>
                    </hx-toolbar-body-section-content-block>
                    <hx-toolbar-body-section-content-block>
                      <div
                        class="d-flex justify-center align-center border-dashed rounded h-100 w-100"
                      >
                        insert component
                      </div>
                    </hx-toolbar-body-section-content-block>
                    <hx-toolbar-body-section-content-block>
                      <div
                        class="d-flex justify-center align-center border-dashed rounded h-100 w-100"
                      >
                        insert component
                      </div>
                    </hx-toolbar-body-section-content-block>
                  </hx-toolbar-body-section>
                </hx-toolbar>
                <v-main class="d-flex align-center justify-center" height="360">
                  <v-container>
                    <v-sheet color="#f4f5f6" height="250" rounded="lg" border="dashed md"></v-sheet>
                  </v-container>
                </v-main>
              </v-layout>
            </v-card-text>
          </v-card>
          <template #configuration>
            <div class="d-flex flex-column mt-16">
              <hx-checkbox v-model="longTitle" :label="`Long title: ${longTitle}`"></hx-checkbox>
              <hx-checkbox
                v-model="longContent"
                :label="`Long content: ${longContent}`"
              ></hx-checkbox>
              <hx-checkbox
                v-model="collapseToolbar"
                :label="`Collapse toolbar: ${collapseToolbar}`"
              ></hx-checkbox>
            </div>
          </template>
        </UsageExample>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <UsageExample v-model="tab" :code="code2" :tabs="tabs">
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Customised</v-card-title>
            <v-card-text class="d-flex ga-3 flex-wrap">
              <v-layout>
                <hx-toolbar
                  id="toolbar-id"
                  v-model:collapsed="collapseToolbar"
                  :header-title="!longTitle ? 'Tools Panel' : 'Tools Panel with a very long title'"
                  header-icon="$i-system-settings"
                >
                  <hx-toolbar-body-section>
                    <hx-search
                      id="search-id"
                      placeholder="Search"
                      icon="mdi-magnify"
                      class="h-25"
                      search=""
                    />
                  </hx-toolbar-body-section>
                  <hx-toolbar-body-section
                    class="flex-grow-1"
                    :style="!longContent ? 'height: 100px' : 'height: 250px'"
                  >
                    <hx-toolbar-body-section-content-block>
                      <hx-content-card class="h-100">Your content go here</hx-content-card>
                    </hx-toolbar-body-section-content-block>
                  </hx-toolbar-body-section>
                </hx-toolbar>
                <v-main class="d-flex align-center justify-center" height="360">
                  <v-container>
                    <v-sheet color="#f4f5f6" height="250" rounded="lg" border="dashed md"></v-sheet>
                  </v-container>
                </v-main>
              </v-layout>
            </v-card-text>
          </v-card>
        </UsageExample>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixToolbar',
  components: { UsageExample },
  setup() {
    const code1 = `
<hx-toolbar id="toolbar-id" v-model:collapsed="collapseToolbar" header-title="Floating title">
  <hx-toolbar-body-section style="height: 100px">
    <div class="d-flex justify-center align-center border-dashed rounded h-100 w-100">
      insert component
    </div>
  </hx-toolbar-body-section>
  <hx-toolbar-body-section>
    <hx-toolbar-body-section-content-block>
      <div class="d-flex justify-center align-center border-dashed rounded h-100 w-100">
        insert component
      </div>
    </hx-toolbar-body-section-content-block>
    <hx-toolbar-body-section-content-block>
      <div class="d-flex justify-center align-center border-dashed rounded h-100 w-100">
        insert component
      </div>
    </hx-toolbar-body-section-content-block>
  </hx-toolbar-body-section>
  <hx-toolbar-body-section>
    <hx-toolbar-body-section-content-block>
      <div class="d-flex justify-center align-center border-dashed rounded h-100 w-100">
        insert component
      </div>
    </hx-toolbar-body-section-content-block>
    <hx-toolbar-body-section-content-block>
      <div class="d-flex justify-center align-center border-dashed rounded h-100 w-100">
        insert component
      </div>
    </hx-toolbar-body-section-content-block>
    <hx-toolbar-body-section-content-block>
      <div class="d-flex justify-center align-center border-dashed rounded h-100 w-100">
        insert component
      </div>
    </hx-toolbar-body-section-content-block>
    <hx-toolbar-body-section-content-block>
      <div class="d-flex justify-center align-center border-dashed rounded h-100 w-100">
        insert component
      </div>
    </hx-toolbar-body-section-content-block>
  </hx-toolbar-body-section>
</hx-toolbar>
    `;
    const code2 = `
<hx-toolbar
      id="toolbar-id"
      v-model:collapsed="collapseToolbar"
      header-title="Tools Panel"
      header-icon="$i-system-settings"
>
  <hx-toolbar-body-section>
    <hx-search
                  id="search-id"
                  placeholder="Search"
                  icon="mdi-magnify"
                  class="h-25"
            />
  </hx-toolbar-body-section>
  <hx-toolbar-body-section class="flex-grow-1">
    <hx-toolbar-body-section-content-block>
      <hx-content-card class="h-100">Your content go here</hx-content-card>
    </hx-toolbar-body-section-content-block>
  </hx-toolbar-body-section>
</hx-toolbar>
`;
    return { code1, code2 };
  },
  data() {
    return {
      tab: 'Toolbar Usage',
      tabs: ['Toolbar Usage'],
      longTitle: false,
      longContent: false,
      collapseToolbar: true
    };
  }
};
</script>
